const getType = (instance) => ({}.toString.call(instance).slice(8, -1)) //.replace(/^\[|\]$|object|\s/g, ''))

const deepEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b) ? true : false

export {
    getType,
    deepEqual,
}